/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForPolicy extends models.ScheduleExecutionParameterServiceAccountBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForPolicy");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForPolicy.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForPolicy>): ScheduleExecutionParameterForPolicy {
        let obj = Object.assign(new ScheduleExecutionParameterForPolicy(), model);
        ScheduleExecutionParameterForPolicy.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForPolicy>): ScheduleExecutionParameterForPolicy {
        if (!model) return null;
        return ScheduleExecutionParameterForPolicy.newInstance(<ScheduleExecutionParameterForPolicy> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForPolicy) {
        if (!obj) return;

        models.ScheduleExecutionParameterForPolicy.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForPolicy): boolean {
        if (models.ScheduleExecutionParameterServiceAccountBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForPolicy.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
